export default __webpack_public_path__ + "e1be24bd0290064a87cc76effb47eb8a.svg";